import React from "react";
import Grid from "@mui/material/Grid";
import Typography from '@mui/material/Typography';
import PocketBalanceInfo from './pocket_balance_info';
import Chip from '@mui/material/Chip';
import UploadFileIcon from '@mui/icons-material/UploadFile';

const SellerPocketBalance = () => {

    const [lastUpdate, setLasUpdate] = React.useState('Sin datos');

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <div style={{display: 'flex', flexDirection: 'row', width:'100%'}}>
                    <Typography variant="h6" component="h6">
                        Cartera mis clientes
                    </Typography>
                </div>
                <hr />
                <Chip color="primary" style={{marginRight: '20px'}} icon={<UploadFileIcon />} label={`Última actualización: ${lastUpdate}`} variant="outlined" />
                {
                    <PocketBalanceInfo setLastUpdate={(date) => setLasUpdate(date)} />
                }                
            </Grid>
        </Grid>
    );
}

export default SellerPocketBalance;